import React from "react";
import { EmblaOptionsType } from "embla-carousel";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";

type PropType = {
    slides: string[];
    options?: EmblaOptionsType;
};

const BullionCarousel: React.FC<PropType> = (props) => {
    const { slides, options } = props;
    const [emblaRef /*, emblaApi */] = useEmblaCarousel(options, [Autoplay({ delay: 2000 })]);

    return (
        <section className="embla m-auto mt-s7 h-[20px] md:mt-0">
            <div className="embla__viewport overflow-hidden" ref={emblaRef}>
                <div className="embla__container flex h-[20px] flex-col">
                    {slides.map((item, index) => (
                        <div
                            className="embla__slide"
                            style={{ transform: "translate3d(0, 0, 0)" }}
                            key={index}
                        >
                            <div className="embla__slide__number flex items-center justify-center gap-2 text-sm leading-[160%] text-neutral-500 md:text-sm">
                                {item}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default BullionCarousel;
